import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-change-language-header',
    templateUrl: './change-language-header.component.html',
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeLanguageHeaderComponent implements OnInit {
    public title: string;
    public availableLanguages: any[] = [];

    form: UntypedFormGroup = new UntypedFormGroup({
        languageId: new UntypedFormControl({ value: null, disabled: true })
    });

    constructor(
        public activeModal: DialogRef,
        private translateService: TranslateService
    ) {}

    ngOnInit() {
        const currentLanguage = this.translateService.getCurrentLang() || localStorage.getItem('language') || 'EN';
        const oppositeLanguage = currentLanguage?.toUpperCase() === 'EN' ? 'BG' : 'EN';
        const languageControl = this.form.get('languageId');
        languageControl.setValue(oppositeLanguage);
    }

    save() {
        const { languageId } = this.form.getRawValue();
        this.activeModal.close(languageId);
    }
}
